
// define the names of all the columns (properties) in a profile's 'extraInfo'
const ColumnNames = {
    memberLastName: 'PARTICIPANT LAST NAME',
    memberFirstName: 'PARTICIPANT FIRST NAME',
    memberDOB: 'BIRTH DATE',
    memberGender: 'SEX',
    hireDate: 'HIRE DATE',
    basePay: 'CY BASE PAY'
}

export {
    ColumnNames
}



// WEBPACK FOOTER //
// ./src/config/fandf/ETL/interfaces.ts